module.exports = __webpack_public_path__ + "img/placeholder-users.4110fc6d.svg";